import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex-grow: 1;
  padding: 32px;
  max-height: 100vh;
  background: ${({ theme }) => theme.color.background};
  overflow-y: auto;
`;
